gsap.registerPlugin(ScrollTrigger);
//gsap.registerPlugin(toggleClass)
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";

const partnersAnim = {
  
    init () {

      /* ADD EVENTLISTENER ON CLICK */
      let partnersList = document.querySelectorAll('.item-container');

      for (let j = 0; j < partnersList.length; j++) {
      
        partnersList[j].addEventListener('click', function (e) {
      
          if (this.children[1].classList.contains('open')) {
            this.children[1].classList.remove('open');
          } else {
            for (let k = 0; k < partnersList.length; k++) {
      
              partnersList[k].children[1].classList.remove('open');
      
            }
      
            this.children[1].classList.add('open');
          }
      
      
        })
      }
      
       ///GSAP

        
    }
}

export default partnersAnim;
